import React, { Component, useState, useEffect, Fragment } from 'react';
import LightBox from '../../components/component-lightbox/component-lightbox';
import GDPRCookieSettingsAcceptCookies from './module-gdpr-cookie-settings-accept-cookies/module-gdpr-cookie-settings-accept-cookies';
import GDPRCookieSettingsCookieSettings from './module-gdpr-cookie-settings-cookie-settings/module-gdpr-cookie-settings-cookie-settings';
import $ from 'jquery';
import classNames from 'classnames';
import T from 'i18n-react';

class ModuleGdprCookieSettingsContainer extends React.Component {
  constructor(props) {
    super(props);
    let defaultGDPRCookieValue;

    if (props.CurrentCookieValue >= 0) {
      defaultGDPRCookieValue = props.CurrentCookieValue;
    }
    else if (!isNaN(props.GDPRAcceptCookiesDefaultLevel)) {
      defaultGDPRCookieValue = Number(props.GDPRAcceptCookiesDefaultLevel);
    }
    else {
      defaultGDPRCookieValue = 2;
    }

    this.state = {
      showModule: props.DefaultView, //AcceptCookies
      defaultGDPRCookieValue: defaultGDPRCookieValue
    };
  }

  componentDidMount() {
    if (this.props.OpenInModal) {
      this.refs.lightbox.open();
    }
  }

  handleHandleChoicesClicked = (e) => {
    this.setState({showModule:'CookieSettings'});
  };

  setGDPRCookieValueHandler = (value) => {
    var expiresGDPRCookie = new Date();
    var expiresGDPRInfoText = new Date();

    expiresGDPRCookie.setMonth(expiresGDPRCookie.getMonth() + 3);
    expiresGDPRInfoText.setDate(expiresGDPRInfoText.getDate() + (6 * 7));

    setTimeout(() => {
      document.cookie = "_vinnova_gdpr=" + value + "; expires=" + expiresGDPRCookie.toUTCString() + "; path=/; SameSite=Lax" + (location.protocol === 'https:' ? '; secure' : '');
      document.cookie = "_vinnova_not_show_information_text_low_gdpr_level=1; expires=" + expiresGDPRInfoText.toUTCString() + "; path=/; SameSite=Lax" + (location.protocol === 'https:' ? '; secure' : '');
    }, 0);

    // Enable tabindex
    $("*[tabindex='-2']").each(function () {
      $(this).attr('tabindex', '0');
    });

    if (window.location.href.includes('&')) {
      window.location.href = window.location.href.replace('forceopengdprcookiesettings=true&', '').replace('&forceopengdprcookiesettings=true', '');
    }
    else {
      window.location.href = window.location.href.replace('?forceopengdprcookiesettings=true', '').replace('&forceopengdprcookiesettings=true', '');
    }

    //this.refs.lightbox.close();
  };

  render() {
    let mainContent;
    let currentModule;

    if (this.state.showModule === 'CookieSettings') {
      currentModule = <GDPRCookieSettingsCookieSettings {...this.props} setGDPRCookieValueHandler={this.setGDPRCookieValueHandler} defaultGDPRCookieValue={this.state.defaultGDPRCookieValue} />;
    }
    else {
      currentModule = <GDPRCookieSettingsAcceptCookies {...this.props} handleHandleChoicesClicked={this.handleHandleChoicesClicked} setGDPRCookieValueHandler={this.setGDPRCookieValueHandler} defaultGDPRCookieValue={this.state.defaultGDPRCookieValue} />;
    }

    if (this.props.OpenInModal) {
      mainContent = (
        <LightBox ref="lightbox" classNames="component-lightbox-gdpr" closeOnOutsideClick={false}>
          {currentModule}
        </LightBox>
      );
    }
    else {
      mainContent = (
          {currentModule}
      );
    }

    return (
      <div>
        {mainContent}
      </div>
    );
  }
}
export default ModuleGdprCookieSettingsContainer;
